import { CONTEXT_MENU_EVENTS } from "Common/Constants";
import { GenerateContextMenuItems } from "Common/Functions";
import { IContextMenuItem } from "Common/Interfaces";

export const getContextMenuItems = (
  handleContextMenuItemClick: (event: CONTEXT_MENU_EVENTS) => void
): IContextMenuItem[] => {
  // Define Context Menu Items for User Management
  const menuItems = [
    {
      event: CONTEXT_MENU_EVENTS.EDIT,
    },
    {
      event: CONTEXT_MENU_EVENTS.DELETE,
    },
  ];

  const authorizedItems = menuItems.map((item) => item.event);

  return GenerateContextMenuItems(authorizedItems).map((item) => ({
    ...item,
    onClick: () => handleContextMenuItemClick(item.event),
  }));
};
